import React, {useState, useEffect} from 'react';
import {
  Button,
  Grid,
  Card,
  CardHeader,
  CardContent,
  TextField,
  Checkbox,
  FormControlLabel,
  Select,
  MenuItem,
  InputLabel,
  Box,
  Modal,
  CircularProgress,
} from '@mui/material';
import {useDispatch} from 'react-redux';
import FormPagePreview from '../HtmlFormGen/component/formPagePreview';
import ModalButtom from '../HtmlFormGen/component/ModalButtom';

import Autocomplete from '@mui/lab/Autocomplete';
import Chip from '@mui/material/Chip';
import Typography from '@mui/material/Typography';
// import {LoadingButton} from '@mui/lab';
import PropTypes from 'prop-types';
// import FormPage from './component/formPage';
import countries from '../../../shared/countries/countries.json'; // Path to your JSON file
import {ChromePicker} from 'react-color'; // Import the ChromePicker component from react-color
import jwtAxios from '@crema/services/auth/jwt-auth';
import {fetchError} from 'redux/actions';
import AppInfoView from '@crema/core/AppInfoView';

const DynamicFormGen = () => {
  const dispatch = useDispatch();
  const [formData, setFormData] = useState({});
  const [selectedApiKey, setSelectedApiKey] = useState('');
  const [apiCredentials, setApiCredentials] = useState([]);
  const [apiCredentialsLoading, setApiCredentialsLoading] = useState(false);
  const [selectedCredential, setSelectedCredential] = useState(null);
  const [ageRanges, setAgeRanges] = useState([[1, 100]]);
  const [questions, setQuestions] = useState([]);
  const [useFullName, setUseFullName] = useState(false);
  const [fields, setFields] = useState([
    {name: 'First Name', required: true},
    {name: 'Last Name', required: true},
    {name: 'Phone Number', required: true},
  ]);
  const [showOptionalQuestions, setShowOptionalQuestions] = useState(false);
  const [ageType, setAgeType] = useState('text');
  const [ageRequired, setAgeRequired] = useState(false);
  const [showAge, setShowAge] = useState(false);
  const [showEmail, setShowEmail] = useState(false);
  const [emailRequired, setEmailRequired] = useState(false);
  const [formPreviewDataJson, setformPreviewDataJson] = useState(null); // Initialize to null or some default value
  const [htmlCode, setHtmlCode] = useState(''); // Replace this with actual HTML code from the backend
  const [isSubmitted, setIsSubmitted] = useState(true);
  const [isGenerated, setIsGenerated] = useState(false);

  useEffect(() => {
    setApiCredentialsLoading(true);
    jwtAxios
      .get('api-credentials')
      .then((res) => {
        const creds = (res.data?.data || res.data || []).filter(
          (c) => !c.is_system_file_upload,
        );
        setApiCredentials(creds);
      })
      .catch(() => {})
      .finally(() => setApiCredentialsLoading(false));
  }, []);

  const defaultCountry = countries.find((country) => country.name === 'Qatar');
  const [selectedCountry, setSelectedCountry] = useState(defaultCountry);
  const [headerTitle, setHeaderTitle] = useState('');
  const [selectedLanguage, setSelectedLanguage] = useState('Arabic'); // Default is Arabic
  const [buttonColor, setButtonColor] = useState('#7C0909'); // State to store the selected button color
  const [buttonTextColor, setButtonTextColor] = useState('#ffffff'); // State to store the selected button color
  const [labelsColor, setLabelsColor] = useState('#000000'); // State to store the selected button color

  const languages = ['Arabic', 'English'];
  const [buttonText, setButtonText] = useState(
    selectedLanguage === 'Arabic' ? 'إرسال' : 'submit',
  );
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleChange = (e, field) => {
    setFormData({
      ...formData,
      [field]: e.target.value,
    });
  };

  const handleCountryChange = (e) => {
    // get the selected country from your list
    const country = countries.find(
      (country) => country.name === e.target.value,
    );
    setSelectedCountry(country);
  };

  const handleButtonColorChange = (color) => {
    setButtonColor(color.hex);
  };
  const handleButtonTextColorChange = (color) => {
    setButtonTextColor(color.hex);
  };

  const handleLabelsColorColorChange = (color) => {
    setLabelsColor(color.hex);
  };
  const handleFieldRequiredChange = (e, index) => {
    const newFields = [...fields];
    newFields[index].required = e.target.checked;
    setFields(newFields);
  };

  const handleFullNameToggle = (checked) => {
    setUseFullName(checked);
    if (checked) {
      setFields([
        {name: 'Full Name', required: true},
        {name: 'Phone Number', required: true},
      ]);
    } else {
      setFields([
        {name: 'First Name', required: true},
        {name: 'Last Name', required: true},
        {name: 'Phone Number', required: true},
      ]);
    }
  };

  const handleAddAgeRange = () => {
    setAgeRanges([...ageRanges, [1, 100]]);
  };

  const handleAgeRangeChange = (e, rangeIndex, boundaryIndex) => {
    const newAgeRanges = [...ageRanges];

    newAgeRanges[rangeIndex][boundaryIndex] = e.target.value;
    setAgeRanges(newAgeRanges);
  };

  const handleAddQuestion = () => {
    setQuestions([
      ...questions,
      {question: '', type: 'text', options: [], required: false},
    ]);
  };
  const handleButtonText = (e) => {
    setButtonText(e);
  };
  const handleHeaderTitle = (e) => {
    setHeaderTitle(e);
  };
  const handleSetEmailReq = (e) => {
    if (showEmail) {
      setEmailRequired(e);
    } else {
      dispatch(fetchError('Please enable email option first'));
    }
  };
  const handelSetAgeRequired = (e) => {
    if (showAge) {
      setAgeRequired(e);
    } else {
      dispatch(fetchError('Please Enable Age Option First'));
    }
  };
  const handelSetEmailShow = (e) => {
    if (!e) {
      setShowEmail(e);
      setEmailRequired(e);
    } else {
      setShowEmail(e);
    }
  };
  const handelSetShowAge = (e) => {
    if (!e) {
      setShowAge(e);
      setAgeRequired(e);
    } else {
      setShowAge(e);
    }
  };
  const handleLanguageChange = (e) => {
    setSelectedLanguage(e);
    setButtonText(e === 'Arabic' ? 'إرسال' : 'submit');
  };
  const handleQuestionChange = (e, index, field) => {
    const newQuestions = [...questions];
    if (field === 'options') {
      newQuestions[index][field] = e.target.value;
    } else if (field === 'required') {
      newQuestions[index][field] = e.target.checked; // Use checked property for checkbox
    } else {
      newQuestions[index][field] = e.target.value;
      if (field === 'type' && e.target.value === 'text') {
        newQuestions[index].options = [];
      }
    }
    setQuestions(newQuestions);
  };
  const handleSubmitPreview = (e) => {
    e.preventDefault();

    // Create a JSON object to store the form data
    const formPreviewDataJson = {
      id: 99999999,
      MPC_4: formData.mpc4 || '',
      marks: formData.marks || '',
      country: selectedCountry,
      form_info: {
        country: selectedCountry,
        language: selectedLanguage,
        showAge: showAge,
        showEmail: showEmail,
        formName: formData.formName,
        mpc4: formData.mpc4,
        emailRequired: emailRequired,
        marks: formData.marks,
        headerTitle: headerTitle ? headerTitle : '',
        useFullName: useFullName,
        apiKey: selectedApiKey,
        fields: fields.map((field) => ({
          name: field.name,
          required: field.required,
        })),
        ageRequired: ageRequired,
        buttonColor: buttonColor,
        labelsColor: labelsColor,
        buttonText: buttonText,
        buttonTextColor: buttonTextColor,
        ageType: ageType,
        ageRanges: ageType === 'range' ? ageRanges : null,
        questions: questions.map((question) => ({
          question: question.question,
          type: question.type,
          options: question.type === 'dropdown' ? question.options : null,
          required: question.required,
        })),
      },
    };
    setformPreviewDataJson(formPreviewDataJson);
    setIsGenerated(false);
    handleOpen(true);
  };
  const handleSubmit = (e) => {
    e.preventDefault();

    // Create a JSON object to store the form data
    const formDataJson = {
      country: selectedCountry,
      language: selectedLanguage,
      showAge: showAge,
      showEmail: showEmail,
      formName: formData.formName,
      mpc4: formData.mpc4,
      emailRequired: emailRequired,
      marks: formData.marks,
      headerTitle: headerTitle ? headerTitle : '',
      useFullName: useFullName,
      apiKey: selectedApiKey,
      fields: fields.map((field) => ({
        name: field.name,
        required: field.required,
      })),
      ageRequired: ageRequired,
      buttonColor: buttonColor,
      labelsColor: labelsColor,
      buttonText: buttonText,
      buttonTextColor: buttonTextColor,
      ageType: ageType,
      ageRanges: ageType === 'range' ? ageRanges : null,
      questions: questions.map((question) => ({
        question: question.question,
        type: question.type,
        options: question.type === 'dropdown' ? question.options : null,
        required: question.required,
      })),
    };
    setformPreviewDataJson(formDataJson);
    setIsSubmitted(true);
    jwtAxios
      .post('forms/', {
        MPC_4: formDataJson.mpc4,
        form_info: formDataJson,
        country: formDataJson.country.iso,
        marks: formDataJson.marks,
      })
      .then((e) => {
        setHtmlCode(
          `<iframe src="https://www.blackdawn.info/forms/${e.data?.data?.id}" width="640" height="956" frameborder="0" marginheight="0" marginwidth="0">Loading…</iframe>`,
        );
      })
      .catch((e) => {
        dispatch(fetchError(e.message));
      })
      .finally(() => {
        setIsSubmitted(true);
        setIsGenerated(true);
      });
    // Perform any additional logic or API calls with formDataJson as needed
  };

  return (
    <>
      <AppInfoView />
      <form onSubmit={handleSubmit}>

        {/* ── 1. Form Identity ── */}
        <Box marginBottom={2}>
          <Card>
            <CardHeader subheader='Form Identity' />
            <CardContent>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={6} md={4}>
                  <TextField
                    label='Form Name'
                    required
                    fullWidth
                    onChange={(e) => handleChange(e, 'formName')}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <TextField
                    label='MPC4'
                    required
                    fullWidth
                    onChange={(e) => handleChange(e, 'mpc4')}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <TextField
                    label='Form Title'
                    fullWidth
                    placeholder='Displayed at top of form'
                    onChange={(e) => handleHeaderTitle(e.target.value)}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <InputLabel>Country</InputLabel>
                  <Select
                    value={selectedCountry ? selectedCountry.name : ''}
                    fullWidth
                    onChange={handleCountryChange}
                  >
                    {countries.map((country, index) => (
                      <MenuItem value={country.name} key={index}>
                        <img
                          loading='lazy'
                          width='20'
                          src={`https://flagcdn.com/w20/${country.iso.toLowerCase()}.png`}
                          srcSet={`https://flagcdn.com/w40/${country.iso.toLowerCase()}.png 2x`}
                          alt=''
                          style={{marginRight: 8}}
                        />
                        {country.name}
                      </MenuItem>
                    ))}
                  </Select>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <InputLabel>Language</InputLabel>
                  <Select
                    value={selectedLanguage}
                    fullWidth
                    onChange={(e) => handleLanguageChange(e.target.value)}
                  >
                    {languages.map((language, index) => (
                      <MenuItem value={language} key={index}>
                        {language}
                      </MenuItem>
                    ))}
                  </Select>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <Autocomplete
                    options={apiCredentials}
                    loading={apiCredentialsLoading}
                    value={selectedCredential}
                    getOptionLabel={(option) => option.credential_name || ''}
                    isOptionEqualToValue={(option, value) => option.id === value?.id}
                    onChange={(_, newValue) => {
                      setSelectedCredential(newValue);
                      setSelectedApiKey(newValue ? newValue.api_key : '');
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label='API Key'
                        required
                        InputProps={{
                          ...params.InputProps,
                          endAdornment: (
                            <>
                              {apiCredentialsLoading ? (
                                <CircularProgress color='inherit' size={16} />
                              ) : null}
                              {params.InputProps.endAdornment}
                            </>
                          ),
                        }}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    label='Marks'
                    required
                    fullWidth
                    multiline
                    rows={3}
                    onChange={(e) => handleChange(e, 'marks')}
                  />
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Box>

        {/* ── 2. Appearance ── */}
        <Box marginBottom={2}>
          <Card>
            <CardHeader subheader='Appearance' />
            <CardContent>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={4}>
                  <InputLabel gutterBottom>Button & Border Color</InputLabel>
                  <ChromePicker
                    color={buttonColor}
                    onChange={handleButtonColorChange}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <InputLabel gutterBottom>Button Text Color</InputLabel>
                  <ChromePicker
                    color={buttonTextColor}
                    onChange={handleButtonTextColorChange}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <InputLabel gutterBottom>Label Color</InputLabel>
                  <ChromePicker
                    color={labelsColor}
                    onChange={handleLabelsColorColorChange}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    label='Button Text'
                    variant='outlined'
                    fullWidth
                    value={buttonText}
                    onChange={(e) => handleButtonText(e.target.value)}
                  />
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Box>

        {/* ── 3. Fields & Options ── */}
        <Box marginBottom={2}>
          <Card>
            <CardHeader subheader='Fields & Options' />
            <CardContent>
              <Grid container spacing={2}>

                {/* Name */}
                <Grid item xs={12}>
                  <Typography variant='subtitle2' color='text.secondary'>
                    Name Field
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={useFullName}
                        onChange={(e) => handleFullNameToggle(e.target.checked)}
                      />
                    }
                    label='Use single Full Name field (instead of First & Last Name)'
                  />
                </Grid>
                {fields.map((field, index) => (
                  <Grid item xs={12} sm={6} md={4} key={index}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={field.required}
                          onChange={(e) => handleFieldRequiredChange(e, index)}
                        />
                      }
                      label={`${field.name} Required`}
                    />
                  </Grid>
                ))}

                {/* Email */}
                <Grid item xs={12} sx={{mt: 1}}>
                  <Typography variant='subtitle2' color='text.secondary'>
                    Email
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={showEmail}
                        onChange={(e) => handelSetEmailShow(e.target.checked)}
                      />
                    }
                    label='Show Email'
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={emailRequired}
                        onChange={(e) => handleSetEmailReq(e.target.checked)}
                      />
                    }
                    label='Email Required'
                  />
                </Grid>

                {/* Age */}
                <Grid item xs={12} sx={{mt: 1}}>
                  <Typography variant='subtitle2' color='text.secondary'>
                    Age
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={showAge}
                        onChange={(e) => handelSetShowAge(e.target.checked)}
                      />
                    }
                    label='Show Age'
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={ageRequired}
                        onChange={(e) => handelSetAgeRequired(e.target.checked)}
                      />
                    }
                    label='Age Required'
                  />
                </Grid>
                {showAge && (
                  <Grid item xs={12} sm={4}>
                    <InputLabel>Age Input Type</InputLabel>
                    <Select
                      value={ageType}
                      fullWidth
                      onChange={(e) => setAgeType(e.target.value)}
                    >
                      <MenuItem value='text'>Text</MenuItem>
                      <MenuItem value='range'>Range</MenuItem>
                    </Select>
                  </Grid>
                )}
                {ageType === 'range' && showAge &&
                  ageRanges.map((range, rangeIndex) => (
                    <Grid item xs={12} sm={6} key={rangeIndex}>
                      <Box display='flex' gap={2}>
                        <TextField
                          label='From'
                          type='number'
                          value={range[0]}
                          fullWidth
                          onChange={(e) => handleAgeRangeChange(e, rangeIndex, 0)}
                        />
                        <TextField
                          label='To'
                          type='number'
                          value={range[1]}
                          fullWidth
                          onChange={(e) => handleAgeRangeChange(e, rangeIndex, 1)}
                        />
                      </Box>
                    </Grid>
                  ))}
                {ageType === 'range' && showAge && (
                  <Grid item xs={12}>
                    <Button variant='outlined' size='small' onClick={handleAddAgeRange}>
                      + Add Age Range
                    </Button>
                  </Grid>
                )}

                {/* Custom questions toggle */}
                <Grid item xs={12} sx={{mt: 1}}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={showOptionalQuestions}
                        onChange={(e) => setShowOptionalQuestions(e.target.checked)}
                      />
                    }
                    label='Add Custom Questions'
                  />
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Box>

        {/* ── 4. Custom Questions ── */}
        {showOptionalQuestions && (
          <Box marginBottom={2}>
            <Card>
              <CardHeader subheader='Custom Questions' />
              <CardContent>
                {questions.map((question, index) => (
                  <Box
                    key={index}
                    sx={{mb: 2, p: 2, border: '1px solid', borderColor: 'divider', borderRadius: 1}}
                  >
                    <Grid container spacing={2} alignItems='center'>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          fullWidth
                          label={`Question ${index + 1}`}
                          value={question.question}
                          onChange={(e) => handleQuestionChange(e, index, 'question')}
                        />
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <InputLabel>Type</InputLabel>
                        <Select
                          fullWidth
                          value={question.type}
                          onChange={(e) => handleQuestionChange(e, index, 'type')}
                        >
                          <MenuItem value='text'>Text</MenuItem>
                          <MenuItem value='dropdown'>Dropdown</MenuItem>
                        </Select>
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={question.required}
                              onChange={(e) => handleQuestionChange(e, index, 'required')}
                            />
                          }
                          label='Required'
                        />
                      </Grid>
                      {question.type === 'dropdown' && (
                        <Grid item xs={12}>
                          <Autocomplete
                            multiple
                            freeSolo
                            options={[]}
                            onChange={(event, newValue) =>
                              handleQuestionChange(
                                {target: {value: newValue}},
                                index,
                                'options',
                              )
                            }
                            renderTags={(value, getTagProps) =>
                              value.map((option, i) => (
                                <Chip
                                  variant='outlined'
                                  label={option}
                                  {...getTagProps({index: i})}
                                  key={i}
                                />
                              ))
                            }
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                variant='outlined'
                                label='Dropdown Options'
                                placeholder='Type and press Enter'
                              />
                            )}
                          />
                        </Grid>
                      )}
                    </Grid>
                  </Box>
                ))}
                <Button variant='outlined' onClick={handleAddQuestion}>
                  + Add Question
                </Button>
              </CardContent>
            </Card>
          </Box>
        )}

        {/* ── 5. Generate ── */}
        <Box marginBottom={2}>
          <Card>
            <CardHeader subheader='Generate Form' />
            <CardContent>
              <Box display='flex' gap={2} alignItems='center' flexWrap='wrap'>
                <Button
                  type='submit'
                  variant='contained'
                  color='primary'
                  disabled={isSubmitted}
                >
                  Generate
                </Button>
                <Button
                  onClick={handleSubmitPreview}
                  variant='outlined'
                  color='secondary'
                >
                  Preview
                </Button>
              </Box>
              {isGenerated && (
                <Typography
                  variant='body2'
                  color='success.main'
                  fontWeight='bold'
                  sx={{mt: 2}}
                >
                  Form created successfully. Modify settings and preview before creating another.
                </Typography>
              )}
              {htmlCode && (
                <Box mt={3}>
                  <Typography variant='subtitle2' gutterBottom>
                    Iframe Embed Code
                  </Typography>
                  <TextField
                    fullWidth
                    multiline
                    rows={5}
                    value={htmlCode}
                    variant='outlined'
                    InputProps={{readOnly: true}}
                  />
                </Box>
              )}
            </CardContent>
          </Card>
        </Box>

      </form>

      {/* Preview Modal */}
      {open && (
        <Modal open={open} onClose={handleClose}>
          <Grid
            container
            alignItems='center'
            justifyContent='center'
            style={{
              backgroundColor: 'rgba(0,0,0,0.5)',
              height: '100vh',
              overflow: 'auto',
            }}
          >
            <Grid item xs={12} sm={9} md={6}>
              <Box
                style={{
                  backgroundColor: 'white',
                  outline: 'none',
                  padding: '1rem',
                  maxHeight: '80vh',
                  overflow: 'auto',
                }}
              >
                <CardContent>
                  <Typography mb={2}>
                    When you use Iframe tag the Form Will Appear Like This
                  </Typography>
                  <FormPagePreview disabled data={formPreviewDataJson} />
                  <ModalButtom
                    handleClose={handleClose}
                    setIsSubmitted={setIsSubmitted}
                    setHtmlCode={setHtmlCode}
                  />
                </CardContent>
              </Box>
            </Grid>
          </Grid>
        </Modal>
      )}
    </>
  );
};

DynamicFormGen.propTypes = {
  description: PropTypes.node,
};

export default DynamicFormGen;
